import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Popover } from 'foundations-components/transitional/components/Popover';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error no types
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import Links from '../../constants/Links';
import { trackViewForecastUsersPopover } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ForecastUsersPopover = ({
  isDetailPage
}) => {
  const [open, setOpen] = useState(false);
  const isDealStageView = useSelector(getIsDealStageView);
  return /*#__PURE__*/_jsx(Popover, {
    inlineSize: "380px",
    open: open,
    onOpenChange: useCallback(e => {
      setOpen(e.target.value);
    }, []),
    closeOnOutsideClick: true,
    placement: "left",
    content: {
      body: /*#__PURE__*/_jsxs(Text, {
        as: "div",
        paddingBlockEnd: "300",
        typography: "detail-200",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastUsersPopover.header"
        }), ' ', /*#__PURE__*/_jsxs(List, {
          marginBlockEnd: "200",
          paddingInlineStart: "600",
          styled: true,
          children: [/*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "repOverviewTable.forecastUsersPopover.checkSalesSeats_jsx",
              options: {
                external: true,
                href: Links.PAID_SALES_SEATS
              },
              elements: {
                Link
              }
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "repOverviewTable.forecastUsersPopover.checkTeams"
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "repOverviewTable.forecastUsersPopover.forecastPermissionsSet_jsx",
              options: {
                external: true,
                href: Links.USER_SETTINGS
              },
              elements: {
                Link
              }
            })
          })]
        }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: Links.SET_UP_FORECAST_TOOL_KB
        })]
      })
    },
    children: /*#__PURE__*/_jsx(UIButton, {
      "aria-pressed": open,
      use: "transparent",
      onClick: () => {
        if (!open) {
          trackViewForecastUsersPopover({
            isDealStageView,
            isDetail: isDetailPage
          });
        }
        setOpen(!open);
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          title: undefined,
          marginInlineEnd: "200"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastUsersPopover.forecastUsers"
        })]
      })
    })
  });
};